import React from "react";

import { useAppSelector } from "../../hooks";
import { getCurrentUser } from "../../store/userStore";
import HydrovacTicketView from "./hydrovac-ticket-view";
import HydrovacDriverForm from "./hydrovac-driver-form";

/**
 * /hydrovac/:id - the hydrovac counterpart to /ticket/:id. Anonymous drivers
 * get the dispatch form, signed-in staff the full edit view.
 */
const HydrovacTicketRoute = () => {
  const user = useAppSelector(getCurrentUser);

  return user ? <HydrovacTicketView /> : <HydrovacDriverForm />;
};

export default HydrovacTicketRoute;
